import api from "./api";

export const getsDescuento = async () => {
    const response = await api.get("/Descuento/GetsDescuento");
    return response.data.data;
}

export const getsDescuentoActivos = async () => {
    const response = await api.get("/Descuento/GetsDescuentoActivos");
    return response.data.data;
}

export const getDescuento = async (idDescuento) => {
    const response = await api.get("/Descuento/GetDescuento?idDescuento=" + idDescuento);
    return response.data.data;
}

// Registrar un descuento es una accion sensible: si quien registra no tiene
// "descuento.editar", tiene que mandar el token de la aprobacion (el que
// devuelve Seguridad/VerificarCredenciales) en la cabecera "X-Autorizacion".
export const addUpdateDescuento = async (dataPost, token = "") => {
    const response = await api.post("/Descuento/AddUpdateDescuento", dataPost, {
        headers: token ? { "X-Autorizacion": token } : {},
    });
    return response.data.data;
}

export const annulDescuento = (idDescuento) =>
    api.post("/Descuento/AnnulDescuento?idDescuento=" + idDescuento);

export const activeDescuento = (idDescuento) =>
    api.post("/Descuento/ActiveDescuento?idDescuento=" + idDescuento);

export default {
    getsDescuento,
    getsDescuentoActivos,
    getDescuento,
    addUpdateDescuento,
    annulDescuento,
    activeDescuento,
};